import React from 'react';
import {observer} from 'mobx-react';
import {TechseeBaseComponent} from '@techsee/techsee-ui-common/lib/_shared/techsee-base-component';
import {RightBarSection} from '../../section';
import {IVisualScanHistoryController} from './VisualScanHistoryController';
import Translate from '../../../translate/Translate';
import './VisualScanHistorySection.scss';
import {VisualScanHistory} from '../../../visual-scan-history/VisualScanHistory';

interface WifiScanHistorySectionProps {
    ctrl: IVisualScanHistoryController;
}

@observer
export class VisualScanHistorySection extends TechseeBaseComponent<WifiScanHistorySectionProps> {
    renderInternal(): JSX.Element {
        const {ctrl} = this.props;

        if (!ctrl.shouldShow) {
            return <></>;
        }

        return (
            <RightBarSection
                isOpen={ctrl.sectionOpen}
                onToggle={ctrl.toggleSection}
                useNewInterface={ctrl.useNewInterface}
                dir={ctrl.dir}
                className='history-list-group'
                title={
                    <>
                        <Translate text={ctrl.visualScanTranslation} />
                    </>
                }>
                {ctrl.isEmpty ? (
                    <div className='panel-empty'>
                        <Translate text='MAIN.VIEW.NO_WIFI_SCAN_HISTORY_FOR_CUSTOMER' />
                    </div>
                ) : (
                    <>
                        <VisualScanHistory
                            onClickWifiScanHistoryButton={ctrl.onClickVisualScanHistoryButton}
                            wifiScanHistoryData={ctrl.visualScanHistoryData}
                            visualScanTranslation={ctrl.visualScanTranslation}
                        />
                    </>
                )}
            </RightBarSection>
        );
    }
}
